import React from "react";

const Modal = ({ isOpen, onClose, users }) => {
  if (!isOpen) return null; 

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-5 z-10 max-w-2xl">
        <h2 className="text-lg font-bold mb-4 text-[#333]">
          Danh sách người dùng
        </h2>
        <div className="flex flex-wrap gap-2">
          {users.length > 0 ? (
            users.map((user, index) => (
              <div key={index} className={`border p-2 rounded ${index % 2 === 0 ? 'bg-gray-100' : 'bg-gray-200'} text-[#333]`}>
                {user}
              </div>
            ))
          ) : (
            <div className="text-center">Không có người dùng nào.</div>
          )}
        </div>
        <button
          className="mt-4 bg-blue-500 text-white rounded px-4 py-2"
          onClick={onClose}
        >
          Đóng
        </button>
      </div>
    </div>
  );
};

export default Modal;
